<template>
  <div>
    <fob-entity-header
      type="Public.headline.organisationalUnit"
      style="margin-bottom: 0rem; font-weight: bold;"
    ></fob-entity-header>
    <div>
      <fob-public-select-tag view="ou"></fob-public-select-tag>
      <!-- OU SEARCH -->
      <b-field grouped style="margin-top: 1rem;">
        <b-field style="margin: 0 1rem 1rem 0; min-width: 300px; display: block;">
          <b-autocomplete
              v-model="searchStr"
              icon="search"
              :data="data"
              :loading="isFetching"
              :clear-on-select="true"
              :placeholder="$gettext('Public.placeholder.ousearch')"
              @input="loadAsyncOrganisationalUnits"
              @select="selectOrganisationalUnit">

              <template slot-scope="ou">
                <div class="media">
                  {{ ou.option.title }}
                </div>
              </template>
          </b-autocomplete>
        </b-field>
        <b-tooltip square position="is-top" :label="$gettext(`form.xbutton`)" style="min-width: 35px;">
            <button tabindex="-1" class="button contol is-aquamarine" @click="searchStr = ''">
              <b-icon icon="times" size="is-small"></b-icon>
            </button>
          </b-tooltip>
      </b-field>

      <hr class="fob-public-select-divider" align="left" />

      <!-- OU TREE -->
      <fob-tree></fob-tree>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { graphql } from '@/axios'
import { fetchOrganisationalUnits } from '@/graphql'
import debounce from 'es6-promise-debounce'
import EntityHeader from '@/components/EntityHeader'
import PublicSelectTag from '@/components/public/PublicSelectTag'
import PublicViewHelper from '@/components/mixins/PublicViewHelper'
import TooltipHelper from '@/components/mixins/TooltipHelper'
import Tree from '@/components/tree/Tree'

export default {
  name: 'fob-public-select-organisational-unit',
  mixins: [PublicViewHelper, TooltipHelper],
  data () {
    return {
      data: [],
      isFetching: false,
      maxLengthOfTags: 46, // will also set by TooltipHelper - default: 30
      searchStr: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedOrganisationalUnit: 'tree/selected'
    })
  },
  methods: {
    ...mapActions({
      resetSelectedTreeItem: 'tree/reset',
      selectBranch: 'tree/selectBranch'
    }),
    loadAsyncOrganisationalUnits: debounce(function (text) {
      if (text && text.length > 0) {
        this.isFetching = true
        // clear previous results
        this.data = []
        // graphql options
        let opts = {
          sortOrder: 'ASC',
          orderBy: 'TITLE_DE',
          filter: {
            text
          }
        }
        // start fetching ous
        graphql(fetchOrganisationalUnits(opts))
        .then(response => {
          this.data = response.data.data.organisationalUnits.entries
          this.isFetching = false
        })
        .catch(() => {
          this.isFetching = false
        })
      }
    }, 500),
    selectOrganisationalUnit (ou) {
      this.setRoute('ou', ou.id)
      this.selectBranch({ id: ou.id, name: ou.name })
    },
    setRoute (type, id) {
      let to = {
        name: 'public',
        params: {
          type,
          id,
          resourceType: this.activeResourceType
        }
      }
      this.$router.replace(to)
    }
  },
  components: {
    'fob-tree': Tree,
    'fob-entity-header': EntityHeader,
    'fob-public-select-tag': PublicSelectTag
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/public/PublicSelectOrganisationalUnit.vue